import SVGEditorShieldTwo from "@/components/forge/SVGEditorShieldTwo";
import { useEffect, useState } from "react";

interface ForgeShieldTwoPageProps {
    rawSvgContent: string;
}

export default function ForgeShieldTwoPage({
    rawSvgContent,
}: ForgeShieldTwoPageProps) {
    const [svgContent, setSvgContent] = useState<string | null>(null);

    // Set the SVG content directly from the imported string
    useEffect(() => {
        setSvgContent(rawSvgContent);
    }, [rawSvgContent]);

    if (!svgContent) {
        return <div>Loading...</div>;
    }

    return (
        <div className="flex h-full flex-col items-center justify-center">
            <SVGEditorShieldTwo svgContent={svgContent} />
        </div>
    );
}
